import * as React from "react";

function ExpandCategoryIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				d="m6 7l6 6l6-6m-1 11H7"
			></path>
		</svg>
	);
}

export default ExpandCategoryIcon;
